export default (props, e) => {
	const inputValue = e.target.value;
	if(inputValue.length >= 5 && inputValue.charAt(inputValue.length - 1) === ' ') {
		e.target.value = inputValue.slice(0, -1);
	}
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/webActions/postCodeValidation.js